import styled from 'styled-components'
import { SIZES } from '../../../styles/theme'

export const OralPresentionStyle = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 150px);
  ${SIZES.mobile} {
    height: calc(100vh - 40px);
    overflow-y: scroll;
    padding-bottom: 200px;
  }

  #vimeoContainer {
    // Vimeo default styling
    padding: 56.25% 0 0 0;
    position: relative;
    flex: 1;
  }
  #bottomSection {
    color: white;
    background: #2d2c3c;
    padding: 30px 60px;
    font-size: 15px;
    ${SIZES.mobile} {
      padding: 20px;
      font-size: 11px;
    }

    .abstractTitle {
      font-weight: 400;
      letter-spacing: 1px;
      font-size: 1.5em;
    }

    .authorName {
      letter-spacing: 1px;
      margin-top: 15px;
      font-size: 1.2em;
    }

    .interactionSection {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 50px;
      ${SIZES.mobile} {
        margin-top: 30px;
        display: block;
      }
    }
  }
`
